module.exports = __webpack_public_path__ + "static/media/surf.88ab6fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Explore/images/surf.jpg
// module id = 1596
// module chunks = 0